import { render, staticRenderFns } from "./BDXMatchPendingManager.vue?vue&type=template&id=41d7f265&scoped=true"
import script from "./BDXMatchPendingManager.vue?vue&type=script&lang=js"
export * from "./BDXMatchPendingManager.vue?vue&type=script&lang=js"
import style0 from "./BDXMatchPendingManager.vue?vue&type=style&index=0&id=41d7f265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d7f265",
  null
  
)

export default component.exports